import {useQuery} from '@apollo/client';
import { GET_ORDERS } from '../Queries/order';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const UseGetAllOrders = (lang) => {

    const [variables,SetVariables] = useState({
        searchText:"",
        limit:40,
        offset:0
    });

    const {t} = useTranslation();
    const [content,SetContent] = useState(null);
    const [selectedOrderIDs,SetSelectedOrderIDs] = useState([]);

    const {data,loading,error,fetchMore,refetch} = useQuery(GET_ORDERS,{
        variables,
        fetchPolicy:"network-only"
    })
    
    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllOrders);
            SetContent(contentData);
        }

    },[data])

    var headerData = [
        {
            value: t("OrderNumber"),
            className:"flex-1"
        },
        {
            value: t("OrderDate"),
            className:"static text-center"
        },
        {
            value: t("DateAdd"),
            className:"static text-center"
        },
        {
            value: t("NameAndSurname"),
            className:"static text-center"
        },
        {
            value: t("Email"),
            className:"flex-1 text-center"
        },
        {
            value: t("Tel"),
            className:"static text-center"
        },
        {
            value: t("ComgateStatus"),
            className:"static text-center"
        },
        
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        value:val.orderNumber,
                        className:"flex-1"
                    },
                    {
                        value: (val.orderDate != "0000-00-00 00:00:00" ?
                            dayjs(val.orderDate).format("DD.MM.YYYY HH:mm:ss")
                        : 
                            ""
                        ),
                        className:"static text-center"
                    },
                    {
                        value: dayjs(val.dateAdd).format("DD.MM.YYYY HH:mm:ss"),
                        className:"static text-center"
                    },
                    {
                        value: val.name + " " + val.surname,
                        className:"static text-center"
                    },
                    {
                        value: val.email,
                        className:"flex-1 text-center"
                    },
                    {
                        value: val.tel,
                        className:"static text-center"
                    },
                    {
                        value: val.onlinePaymentStatus,
                        className:"static text-center"
                    }
                ],
            }

            cData.rowID    = val.orderID;
            cData.selected = false;

            contentData.push(cData)
        }
        return contentData;
    }

    const FetchMore = (offset) => {

        fetchMore({
            variables: {
                offset: offset
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return Object.assign({}, prev, {
                    AllOrders: [...prev.AllOrders, ...fetchMoreResult.AllOrders]
                });
            }
        });
    }

    const GoToPage = (page) => {

        SetVariables((prevValue) => {

            var newOffset = (page - 1) * prevValue.limit;
            if(newOffset == prevValue.offset)
                refetch();

            return {...prevValue,offset:newOffset}

        })
    }

    const SelectRow = (e,orderID) => {

        var checked = e.target.checked;
        var newSelectedOrderIDs = [...selectedOrderIDs];
        const newList = SelectOrderID(content,orderID,checked,newSelectedOrderIDs)

        SetContent(newList);
        SetSelectedOrderIDs(newSelectedOrderIDs);
    }

    const SelectAll = (e) => {

        var checked = e.target.checked;
        var newSelectedOrderIDs = [];
        const newList = SelectOrderID(content,"all",checked,newSelectedOrderIDs)

        SetSelectedOrderIDs(newSelectedOrderIDs);
        SetContent(newList);
    }

    const SelectOrderID = (list,orderID,checked,selectedOrderIDs) => {

        const newList = [...list];
        for(let i = 0; i < newList.length; i++)
        {
            if(orderID == newList[i].rowID || orderID === "all")
            {
                newList[i] = {...newList[i],selected:checked}
                if(checked)
                    selectedOrderIDs.push(newList[i].rowID);
                else
                {
                    for(let j = 0; j < selectedOrderIDs.length; j++)
                    {
                        if(selectedOrderIDs[j] == newList[i].rowID)
                            selectedOrderIDs.splice(j,1);  
                    } 
                }
            }

            if(newList[i].subData)
                newList[i] = {...newList[i],subData:SelectOrderID(newList[i].subData,orderID,checked,selectedOrderIDs)}
        }

        return newList;
    }

    return{
        content,
        headerData,
        loading,
        error,
        selectedOrderIDs,
        totalContentLength: data && data.AllOrdersCount || 0,
        paggingOffset: variables.offset,
        paggingLimit: variables.limit,
        SelectRow,
        SelectAll,
        FetchMore,
        GoToPage
    }

}

export default UseGetAllOrders;